/**
 * 课程模块
 */
import { State } from '@seiue/ui'
import { FC } from 'react'

import { CourseActivityTask, courseApi } from 'packages/sdks-next/growp'

import { OPEN_TASK_ID_ENCODE_KEY } from '@/features/types'
import { useParams } from '@/router'
import { decodeString } from '@/utils/url'

import { CourseContent } from './CourseContent'
import { FullscreenEmpty } from '@/components/FullscreenEmpty'

export interface UserCourseTaskProps {
  previewData?: CourseActivityTask | null
  onPreviewClose?: () => void
}

/**
 * 课程模块
 *
 * @param param0 - 参数
 * @param param0.previewData - 预览数据
 * @param param0.onPreviewClose - 预览关闭回调
 * @returns 课程模块
 */
export const UserCourse: FC<UserCourseTaskProps> = ({
  previewData,
  onPreviewClose,
}) => {
  return previewData ? (
    <CourseContent
      name={previewData.task?.name || '-'}
      isPreview={true}
      taskId={previewData.task?.id || 0}
      onPreviewClose={onPreviewClose}
      outlines={previewData.outlines || []}
    />
  ) : (
    <MainContent />
  )
}

/**
 * 课程模块
 * CourseContent 组件不适合同时渲染预览模式和非预览模式，所以分开
 * 如果不是预览模式，做一些数据请求，尤其是 useParams
 *
 * @returns 课程模块
 */
export const MainContent: FC = () => {
  const { taskMsg } = useParams<'UserCourseTask'>()

  const taskId = decodeString(taskMsg, OPEN_TASK_ID_ENCODE_KEY)
  const { data: courseTask, loading } = courseApi.useLoadCourseActivityTask(
    {
      id: taskId ? Number(taskId) : 0,
      query: {
        expand: [
          'outlines',
          ['outlines', 'tasks'],
          ['outlines', 'tasks', 'attachments'],
        ],
        tryExpand: [
          'taskCompletedInfo',
          ['taskCompletedInfo', 'completedDetails'],
        ],
        isForeground: true,
      },
    },
    { disable: !taskId }
  )

  if (!taskId) return <FullscreenEmpty />
  if (loading) return <State.Loading />
  return (
    <CourseContent
      taskId={Number(taskId)}
      isPreview={false}
      name={courseTask?.task?.name || '-'}
      completedDetails={courseTask?.taskCompletedInfo?.completedDetails}
      outlines={courseTask?.outlines || []}
    />
  )
}
